import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var de = {
  language: 'de',
  country: 'de',
  name: 'Deutsch',
  embeddedLocale: merge(error, login),
  flags: ['DE'],
};

export { de as default };
